export default __webpack_public_path__ + "assets/images/25111e39c9afbe6e12b3075c22e8d3eb.png";